import { useEffect, useState } from "react";

import { supplierInventoryHistoryApi } from "@/main/api";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { getTranslateByKey } from "@/main/services/utils";
import { firstLetterToUpperCase } from "@/main/services/utilsString";

import * as S from "./styles";

interface Props {
	open?: any;
	closeModal?: any;
	guidSupplierInventoryDetail?: string;
	userName?: string;
}

function InventoryEdit({ open, closeModal, guidSupplierInventoryDetail, userName }: Props) {
	const [isLoadingInfo, setIsLoadingInfo] = useState(true);
	const [details, setDetails] = useState([]);

	useEffect(() => {
		if (open) {
			setIsLoadingInfo(true);
			supplierInventoryHistoryApi
				.getHistoryDetail({
					guidSupplierInventoryHistory: String(guidSupplierInventoryDetail),
				})
				.then((response) => {
					const resultData = response.data.result;
					setDetails(resultData);
				})
				.catch(() => {})
				.finally(() => {
					setIsLoadingInfo(false);
				});
		}
	}, [guidSupplierInventoryDetail]);

	return (
		<>
			{open && (
				<KogModalSideComponent
					open={open}
					closeModal={() => {
						closeModal();
						setDetails([]);
					}}
					title={getTranslateByKey("information.historyDetails")}
					id="id-inventoryEdit-modal-scroll"
				>
					<S.AccordionContainer>
						<S.AccordionTitle>{getTranslateByKey("information.inventoryedit")}</S.AccordionTitle>
						{!isLoadingInfo ? (
							<S.AccordionDetailsHistory>
								<S.ContainerLabel>
									<S.LabelItem>{`${getTranslateByKey("information.userName")}:`}</S.LabelItem>
									<S.LabelResult>{userName}</S.LabelResult>
								</S.ContainerLabel>
								{details &&
									details.map((item, index) => (
										<S.BoxLabelItem key={index}>
											<S.ContainerLabel>
												<S.LabelItem>
													{firstLetterToUpperCase(`${getTranslateByKey("SupplierInventoryHistory.field")}:`)}
												</S.LabelItem>
												<S.LabelResult>{item.field}</S.LabelResult>
											</S.ContainerLabel>
											{item.companyType && (
												<S.ContainerLabel>
													<S.LabelItem>{`${getTranslateByKey("information.companyTypeName")}:`}</S.LabelItem>
													<S.LabelResult>{item.companyType}</S.LabelResult>
												</S.ContainerLabel>
											)}
											{item.companyType && (
												<S.ContainerLabel>
													<S.LabelItem>{`${getTranslateByKey("information.company")}:`}</S.LabelItem>
													<S.LabelResult>{item.company}</S.LabelResult>
												</S.ContainerLabel>
											)}
											<S.ContainerLabel>
												<S.LabelItem>{`${getTranslateByKey("information.from")}:`}</S.LabelItem>
												<S.LabelResult>{item.from}</S.LabelResult>
											</S.ContainerLabel>
											<S.ContainerLabel>
												<S.LabelItem>{`${getTranslateByKey("information.to")}:`}</S.LabelItem>
												<S.LabelResult>{item.to}</S.LabelResult>
											</S.ContainerLabel>
										</S.BoxLabelItem>
									))}
							</S.AccordionDetailsHistory>
						) : (
							<LoadingComponent />
						)}
					</S.AccordionContainer>
					<div className="d-flex justify-content-center" style={{ marginTop: 10 }}>
						<SecondaryButton id="id-partImport-button-back" onClick={() => closeModal()}>
							{getTranslateByKey("information.back")}
						</SecondaryButton>
					</div>
				</KogModalSideComponent>
			)}
		</>
	);
}

export default InventoryEdit;
